export const sm = "max-width: 47.9999em";
export const md = "min-width: 48em";
export const lg = "min-width: 64em";
